import { memo, useEffect } from 'react';

import { getStages } from "PDF/helpers/pdfMapping";
import { IPdfPageProps } from "PDF/types/pdf";
import { useBusinessToolStore } from "store/useBusinessToolStore";
import { getBusinessPlanChapters } from "store/useBusinessToolStore/selectors";

export const ImplementationPlan = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);

  const stages = getStages(businessPlanChapters);

  useEffect(() => {
    if (sectionPicture) {
      const data = {
        stages,
      };

      saveSectionProps('implementationPlan', { data });
    }
  }, [sectionPicture]);

  return null;
});
